import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, AlertCircle } from 'lucide-react';

function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setErrorMessage('This unsubscribe link is invalid or has already been used.');
      setStatus('error');
      return;
    }

    fetch(`/api/leads/unsubscribe/${token}`)
      .then(async (res) => {
        if (res.ok) {
          setStatus('success');
        } else {
          const data = await res.json().catch(() => ({}));
          setErrorMessage(data.error || 'This unsubscribe link is invalid or has already been used.');
          setStatus('error');
        }
      })
      .catch(() => {
        setErrorMessage('Something went wrong. Please try again later.');
        setStatus('error');
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Nav */}
      <nav className="bg-white border-b border-gray-200 px-6 py-4">
        <Link to="/" className="flex items-center gap-2 w-fit">
          <img src="/nivasapro.ai-app-Icon.png" alt="NivasaPro" className="h-7 w-7" />
          <span className="text-xl font-bold text-gray-900">NivasaPro</span>
        </Link>
      </nav>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-10 max-w-md w-full text-center">
          {status === 'loading' && (
            <>
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-cyan-600 mx-auto mb-4" />
              <p className="text-gray-500">Processing your request…</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle className="h-14 w-14 text-green-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">You've been unsubscribed</h1>
              <p className="text-gray-500 mb-6">
                You won't receive any further emails from NivasaPro.ai.
              </p>
              <Link
                to="/"
                className="inline-block bg-cyan-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-cyan-700 transition-colors"
              >
                Back to home
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <AlertCircle className="h-14 w-14 text-red-400 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Unable to unsubscribe</h1>
              <p className="text-gray-500 mb-6">{errorMessage}</p>
              <Link
                to="/"
                className="inline-block bg-gray-100 text-gray-700 px-6 py-2 rounded-lg font-medium hover:bg-gray-200 transition-colors"
              >
                Back to home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default UnsubscribePage;
